import angular from "angular";
import { moduleName as recordsModuleName } from "../index";
import {
  ChangeJournalModalService,
  vsServiceName as changeJournalModalServiceName,
} from "./changeNoteModalService/modalService";
import {
  changeJournalViewComponentOptions,
  vsComponentName as changeJournalViewComponentName,
} from "./changeJournalViewComponent";
import {
  vsDirectiveName as changeJournalItemObjectDetailDirectiveName,
  changeJournalItemObjectDetailDirective,
} from "./changeJournalViewComponent/itemObjectDetail/directive";
import {
  ChangeJournalViewItemServiceProvider,
  vsServiceName as ChangeJournalViewItemServiceName,
} from "./changeJournalViewComponent/itemObjectDetail";
import {
  changeJournalItemComponentOptions,
  vsComponentName as changeJournalItemComponentName,
} from "./changeJournalViewComponent/item";

export const vsModuleName = `${recordsModuleName}.changeJournal`;

angular
  .module(vsModuleName, ["ui.bootstrap"])
  .service(changeJournalModalServiceName, ChangeJournalModalService)
  .component(changeJournalViewComponentName, changeJournalViewComponentOptions)
  .directive(
    changeJournalItemObjectDetailDirectiveName,
    changeJournalItemObjectDetailDirective
  )
  .component(changeJournalItemComponentName, changeJournalItemComponentOptions)
  .provider(
    ChangeJournalViewItemServiceName,
    ChangeJournalViewItemServiceProvider
  );
